// namespace
export const PROTEGES_NAMESPACE = 'proteges'

// getters
export const PROTEGES_GETTER = 'proteges'
export const PROTEGES_GETTER_PROTEGE_ALL_INFO = 'allInfoProtege'

// mutations
export const PROTEGES_MUTATION_ENTIRE_PROTEGES = 'updateEntireProteges'
export const PROTEGES_MUTATION_PROTEGE_ALL_INFO = 'updateProtegeAllInfo'
export const PROTEGES_MUTATION_DELETE_PROTEGE = 'deleteProtege'
export const PROTEGES_MUTATION_PHOTOS = 'updatePhotos'

// actions
export const PROTEGES_ACTION_GET_PROTEGES = 'fetchProteges'
export const PROTEGES_ACTION_GET_PROTEGE_ALL_INFO = 'fetchProtegeAllInfo'
export const PROTEGES_ACTION_DELETE_PROTEGE = 'deleteProtege'



// WEBPACK FOOTER //
// ./src/store/modules/proteges-types.js